module.exports = __webpack_public_path__ + "static/media/T.7692a5da.svg";